<template>
    <div>
        <remittance-print :remittance-detail="remittanceDetail" v-if="isPrint" />
        <div class="shadow bg-white rounded-lg pb-10">
            <div class="text-center text-blue-800 p-5 bg-slate-100">
            <span class="inline-block font-bold text-xl ">جزئیات حواله</span>
            </div>
            <div class="mt-5 px-5">
                <div class="info-pack">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-archive</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">اطلاعات محموله</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col cols="auto" sm="6" v-if="remittanceDetail.company_name || remittanceDetail.company?.company_name">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نام شرکت حمل و نقل: </span>
                        <span v-if="remittanceDetail.company_name" class="text-stone-500 text-xs">{{ remittanceDetail.company_name }}</span>
                        <span v-if="remittanceDetail.company?.company_name" class="text-stone-500 text-xs">{{ remittanceDetail.company?.company_name }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نوع کالا: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.productTitle }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نوع بسته بندی: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.packageTypeName }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نوع ناوگان: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.carTypeTitle }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">شماره حواله: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.id }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">وضعیت: </span>
                        <span class="text-stone-500 text-xs">{{ translate(remittanceDetail.status) }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">تاریخ ایجاد: </span>
                        <span class="text-stone-500 text-xs">{{ getPersianDate(remittanceDetail.created_at) }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
                <div class="info-driver mt-10">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-account</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">اطلاعات راننده</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نام و فامیل: </span>
                        <span v-if="remittanceDetail.driver?.name" class="text-stone-500 text-xs">{{ `${remittanceDetail.driver?.name} ${remittanceDetail.driver?.family}` }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد ملی: </span>
                        <span v-if="remittanceDetail.driver?.nationalId" class="text-stone-500 text-xs">{{ remittanceDetail.driver?.nationalId }}</span>
                        <span v-else class="text-stone-500 text-xs">{{ remittanceDetail.nationalId }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">شماره موبایل: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.driver?.mobile }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد هوشمند راننده: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.driver?.smartId }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">پلاک: </span>
                            <plaque :plaque="remittanceDetail.plaque" />
                    </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد هوشمند ماشین: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.car?.smartIdCar }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
                <div class="info-sender mt-10">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-account</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">اطلاعات فرستنده</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نام و فامیل: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.senderDetailNameFamily }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد ملی: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.senderDetailNationalId }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد پستی: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.senderPostalCode }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
                <div class="info-receiver mt-10">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-account</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">اطلاعات گیرنده</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نام و فامیل: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.receiverDetailNameFamily }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد ملی: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.receiverDetailNationalId }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="4">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">کد پستی: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.receiverPostalCode }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
                <div class="info-address mt-10">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-pin</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">آدرس</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">مبدا: </span>
                        <span v-if="remittanceDetail.source_province?.title" class="text-stone-500 text-xs">{{ remittanceDetail.source_province?.title }}</span>
                        <span v-if="remittanceDetail.source_city?.title" class="text-stone-500 text-xs">{{ remittanceDetail.source_city?.title }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">مقصد: </span>
                        <span v-if="remittanceDetail.destination_province?.title" class="text-stone-500 text-xs">{{ remittanceDetail.destination_province?.title }}</span>
                        <span v-if="remittanceDetail.destination_city?.title" class="text-stone-500 text-xs">{{ remittanceDetail.destination_city?.title }}</span>
                        <span v-if="remittanceDetail.province?.title" class="text-stone-500 text-xs">{{ remittanceDetail.province?.title }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">آدرس بارگیری: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.loadingAddress }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">آدرس تخلیه: </span>
                        <span class="text-stone-500 text-xs">{{ remittanceDetail.dischargeAddress }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
                <div class="info-cash mt-10">
                    <div class="title border-b border-stone-200 pb-2 flex items-center">
                    <v-icon size="18" color="info">mdi-cash</v-icon>
                    <span class="mr-1 text-blue-600 font-bold">اطلاعات مالی</span>
                    </div>
                    <v-row class="mt-2">
                    <v-col v-if="remittanceDetail.rentPaymentMethod" cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نوع پرداخت کرایه: </span>
                        <span class="text-stone-500 text-xs">{{ translate(remittanceDetail.rentPaymentMethod) }}</span>
                        </div>
                    </v-col>
                    <v-col v-if="remittanceDetail.rentPaymentStatus" cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">وضعیت پرداخت کرایه: </span>
                        <span class="text-stone-500 text-xs">{{ translate(remittanceDetail.rentPaymentStatus) }}</span>
                        </div>
                    </v-col>
                    <v-col   cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">نوع پرداخت کمیسیون: </span>
                        <span class="text-stone-500 text-xs">{{ translate(remittanceDetail.paymentMethod) }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">وضعیت پرداخت کمیسیون: </span>
                        <span class="text-stone-500 text-xs">{{ translate(remittanceDetail.paymentStatus) }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">ارزش بار: </span>
                        <span v-if="remittanceDetail.worth" class="text-stone-500 text-xs">{{ Seprate(remittanceDetail.worth) }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">قابل پرداخت راننده: </span>
                        <span   class="text-stone-500 text-xs">{{ Seprate(remittanceDetail.waybillCost) }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">مبلغ تخفیف (ریال): </span>
                        <span   class="text-stone-500 text-xs">{{ remittanceDetail.discount? Seprate(remittanceDetail.discount.discount_amount):'- - - - - - ' }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">    کد تخفیف: </span>
                        <span   class="text-stone-500 text-xs">{{ remittanceDetail.discount? remittanceDetail.discount.code:'- - - - - - ' }}</span>
                        </div>
                    </v-col>
                    <v-col cols="auto" sm="6">
                        <div class="flex items-center">
                        <span class="ml-1 text-stone-900 text-xs font-bold">  قابل پرداخت نهایی راننده (ریال): </span>
                        <span   class="text-stone-500 text-lg">{{ remittanceDetail.discount?Seprate(remittanceDetail.waybillCost - remittanceDetail.discount?.discount_amount):'- - - - - - ' }}</span>
                        </div>
                    </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Plaque from "@/components/Plaque.vue";
import RemittancePrint from './RemittancePrint.vue';

export default {
    props: ['remittanceDetail', 'isPrint'],
    components: { Plaque, RemittancePrint },
    data() {
        return {
            // isPrint: false
            // detailBox: this.show ? this.show : false
        }
    },
}
</script>

<style>

</style>